export function buildViewerWatermarkText(session) {
  const id = String(session?.id || session?.session_token || '').slice(0, 8);
  return id ? `SECURE VIEW • SESSION ${id}` : 'SECURE VIEW';
}

export function drawSecureViewerWatermark(ctx, text, width, height) {
  if (!ctx || !width || !height) return;

  const fontSize = Math.max(16, Math.min(28, Math.round(Math.min(width, height) / 28)));
  const stepX = Math.max(260, Math.round(width * 0.38));
  const stepY = Math.max(100, Math.round(height * 0.18));

  ctx.save();
  ctx.translate(width / 2, height / 2);
  ctx.rotate((-32 * Math.PI) / 180);
  ctx.font = `700 ${fontSize}px Arial, sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.lineWidth = Math.max(2, Math.round(fontSize / 10));
  ctx.strokeStyle = 'rgba(255,255,255,0.60)';
  ctx.fillStyle = 'rgba(185,28,28,0.28)';

  for (let y = -height * 1.4; y <= height * 1.4; y += stepY) {
    for (let x = -width * 1.4; x <= width * 1.4; x += stepX) {
      ctx.strokeText(text, x, y);
      ctx.fillText(text, x, y);
    }
  }

  ctx.restore();
}
